import { gql } from '__generated__'

export const LINK_WALLET_CHALLENGE = gql(`
  mutation linkWalletChallenge($walletAddress: String!) {
    linkWalletChallenge(walletAddress: $walletAddress) {
      challenge
    }
  }
`)
